var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.27746 9.82183L9.92329 13.9885C10.0223 14.101 10.165 14.1666 10.315 14.1666C10.465 14.1666 10.6077 14.101 10.7066 13.9885L14.3525 9.82183C14.4868 9.66767 14.5202 9.44996 14.4348 9.2635C14.3933 9.17254 14.3266 9.09541 14.2426 9.0413C14.1586 8.98719 14.0607 8.95837 13.9608 8.95829H11.8775L11.8775 2.18746C11.8775 1.89996 11.6441 1.66663 11.3566 1.66663H9.27329C8.98579 1.66663 8.75246 1.89996 8.75246 2.18746L8.75246 8.95829H6.66913C6.56913 8.95816 6.47122 8.98689 6.38715 9.04102C6.30308 9.09516 6.23642 9.17241 6.19517 9.2635C6.11079 9.44996 6.14204 9.66871 6.27746 9.82183Z",
    fill: "#303238"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0417 13.125V16.25H4.58333V13.125H2.5V17.2917C2.5 17.8677 2.96667 18.3333 3.54167 18.3333H17.0833C17.6594 18.3333 18.125 17.8677 18.125 17.2917V13.125H16.0417Z",
    fill: "#303238"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.611161901dc526711265c00c637734cf.svg";
export { ForwardRef as ReactComponent };